export const architecturalWorks = [
    {
        id: 1,
        slug: 'alwar-rajasthan',
        title: 'Alwar Rajasthan',
        category: 'Residential',
        location: 'Alwar, Rajasthan',
        year: '2022',
        client: 'Private Client',
        images: [
            '/images/portfolio/1/1.jpg',
            '/images/portfolio/1/2.jpg',
            '/images/portfolio/1/3.jpg',
            '/images/portfolio/1/4.jpg',
            '/images/portfolio/1/5.jpg',
            '/images/portfolio/1/6.jpg',
            '/images/portfolio/1/7.jpg'
        ],
        description: 'A contemporary residential project blending modern architecture with traditional Rajasthani elements.'
    },
    {
        id: 2,
        slug: 'apple-pool-villa',
        title: 'Apple Pool Villa',
        category: 'Residential',
        location: 'Surat, Gujarat',
        year: '2022',
        client: 'Private Client',
        images: [
            '/images/portfolio/2/1.jpg',
            '/images/portfolio/2/2.jpg',
            '/images/portfolio/2/3.jpg',
            '/images/portfolio/2/4.jpg',
            '/images/portfolio/2/5.jpg',
            '/images/portfolio/2/6.jpg',
            '/images/portfolio/2/7.jpg',
            '/images/portfolio/2/8.jpg'
        ],
        description: 'Luxury villa featuring an innovative pool design and contemporary architectural elements.'
    },
    {
        id: 3,
        slug: 'bent-architecture',
        title: 'Bent Architecture',
        category: 'Commercial',
        location: 'Surat, Gujarat',
        year: '2022',
        client: 'Commercial Client',
        images: [
            '/images/portfolio/3/1.jpg',
            '/images/portfolio/3/2.jpg',
            '/images/portfolio/3/3.jpg',
            '/images/portfolio/3/4.jpg',
            '/images/portfolio/3/5.jpg',
            '/images/portfolio/3/6.jpg',
            '/images/portfolio/3/7.jpg',
            '/images/portfolio/3/8.jpg',
            '/images/portfolio/3/9.jpg'
        ],
        description: 'Innovative commercial building with unique curved architectural design elements.'
    },
    {
        id: 4,
        slug: 'educational-building',
        title: 'Educational Building',
        category: 'Educational',
        location: 'Surat, Gujarat',
        year: '2022',
        client: 'Educational Institution',
        images: [
            '/images/portfolio/4/1.jpg',
            '/images/portfolio/4/2.jpg',
            '/images/portfolio/4/3.jpg',
            '/images/portfolio/4/4.jpg',
            '/images/portfolio/4/5.jpg',
            '/images/portfolio/4/6.jpg',
            '/images/portfolio/4/10.jpg',
            '/images/portfolio/4/11.jpg',
            '/images/portfolio/4/12.jpg'
        ],
        description: 'Modern educational facility designed to inspire learning with contemporary architecture.'
    },
    {
        id: 5,
        slug: 'highrise-village',
        title: 'Highrise Village',
        category: 'Residential',
        location: 'Surat, Gujarat',
        year: '2022',
        client: 'Real Estate Developer',
        images: [
            '/images/detail/1.jpg',
            '/images/detail/2.jpg',
            '/images/detail/3.jpg',
            '/images/detail/4.jpg',
            '/images/detail/5.jpg'
        ],
        description: 'Multi-story residential complex with modern amenities and sustainable design features.'
    },
    {
        id: 6,
        slug: 'lakeview-center',
        title: 'Lakeview Center',
        category: 'Commercial',
        location: 'Surat, Gujarat',
        year: '2022',
        client: 'Commercial Client',
        images: [
            '/images/detail2/1.jpg',
            '/images/detail2/2.jpg'
        ],
        description: 'Commercial center with stunning lake views and contemporary architectural design.'
    }
];

export const interiorWorks = [
    {
        id: 1,
        slug: 'dancing-column-interior',
        title: 'Dancing Column',
        category: 'Residential',
        location: 'Surat, Gujarat',
        year: '2022',
        client: 'Private Client',
        images: [
            '/images/detail/interior/1.jpg',
            '/images/detail/interior/2.jpg',
            '/images/detail/interior/3.jpg',
            '/images/detail/interior/4.jpg',
            '/images/detail/interior/5.jpg',
            '/images/detail/interior/6.jpg',
            '/images/detail/interior/7.jpg'
        ],
        description: 'Modern residential interior featuring distinctive column designs and contemporary aesthetics.'
    },
    {
        id: 2,
        slug: 'dancing-column-residence',
        title: 'Dancing Column Residence',
        category: 'Residential',
        location: 'Surat, Gujarat',
        year: '2022',
        client: 'Private Client',
        images: [
            '/images/layout/Dancing column residence.jpg',
            '/images/detail2/interior/1.jpg',
            '/images/detail2/interior/2.jpg',
            '/images/detail2/interior/3.jpg',
            '/images/detail2/interior/4.jpg',
            '/images/detail2/interior/5.jpg'
        ],
        description: 'Elegant residential interior with signature dancing column architectural elements.'
    },
    {
        id: 3,
        slug: 'kadir-house',
        title: "Kadir's House",
        category: 'Residential',
        location: 'Surat, Gujarat',
        year: '2022',
        client: 'Private Client',
        images: [
            '/images/detail/interior/1.jpg',
            '/images/detail/interior/2.jpg',
            '/images/detail/interior/3.jpg'
        ],
        description: 'Contemporary residential interior design with modern furnishings and elegant finishes.'
    },
    {
        id: 4,
        slug: 'krishna-sales',
        title: 'Krishna Sales',
        category: 'Commercial',
        location: 'Surat, Gujarat',
        year: '2022',
        client: 'Commercial Client',
        images: [
            '/images/detail/interior/1.jpg',
            '/images/detail/interior/2.jpg'
        ],
        description: 'Commercial interior design creating an inviting and professional business environment.'
    },
    {
        id: 5,
        slug: 'luxury-redefined',
        title: 'Luxury Redefined',
        category: 'Residential',
        location: 'Surat, Gujarat',
        year: '2022',
        client: 'Private Client',
        images: [
            '/images/detail/interior/1.jpg',
            '/images/detail/interior/2.jpg',
            '/images/detail/interior/3.jpg',
            '/images/detail/interior/4.jpg'
        ],
        description: 'High-end residential interior showcasing luxurious materials and sophisticated design.'
    },
    {
        id: 6,
        slug: 'luxury-residence',
        title: 'Luxury Residence',
        category: 'Residential',
        location: 'Surat, Gujarat',
        year: '2022',
        client: 'Private Client',
        images: [
            '/images/detail/interior/1.jpg',
            '/images/detail/interior/2.jpg',
            '/images/detail/interior/3.jpg',
            '/images/detail/interior/4.jpg',
            '/images/detail/interior/5.jpg'
        ],
        description: 'Premium residential interior with refined details and contemporary luxury finishes.'
    },
    {
        id: 7,
        slug: 'makeup-studio',
        title: "Aliya's Makeup Studio",
        category: 'Commercial',
        location: 'Surat, Gujarat',
        year: '2022',
        client: 'Commercial Client',
        images: [
            '/images/detail/interior/1.jpg',
            '/images/detail/interior/2.jpg',
            '/images/detail/interior/3.jpg'
        ],
        description: 'Stylish makeup studio interior with modern amenities and elegant design elements.'
    },
    {
        id: 8,
        slug: 'modern-art-jokha',
        title: 'A Modern Art at Jokha',
        category: 'Residential',
        location: 'Jokha, Surat',
        year: '2022',
        client: 'Private Client',
        images: [
            '/images/layout/A modern Art piece at Jokha.jpg',
            '/images/detail/interior/1.jpg',
            '/images/detail/interior/2.jpg'
        ],
        description: 'Artistic residential interior blending modern art concepts with functional living spaces.'
    },
    {
        id: 9,
        slug: 'param-hospital',
        title: 'Param Hospital',
        category: 'Healthcare',
        location: 'Surat, Gujarat',
        year: '2022',
        client: 'Healthcare Institution',
        images: [
            '/images/detail/interior/1.jpg',
            '/images/detail/interior/2.jpg',
            '/images/detail/interior/3.jpg',
            '/images/detail/interior/4.jpg'
        ],
        description: 'Healthcare facility interior designed for patient comfort and operational efficiency.'
    }
];

export const testimonials = [
    {
        id: 1,
        quote: "Architecture should speak of its time and place, but yearn for timelessness.",
        author: "Abhishek Tamakuwala",
        position: "Chief Architect"
    },
    {
        id: 2,
        quote: "None of this would have been possible without the person who supported me throughout. Thank you Ar. Abhishek Tamakuwala.",
        author: "Ms. Aaliyah Pirzada",
        position: "Vesu"
    },
    {
        id: 3,
        quote: "The design perfectly captured our vision and exceeded our expectations. The attention to detail is remarkable.",
        author: "Mr. Rajesh Patel",
        position: "Client, Alwar Rajasthan"
    },
    {
        id: 4,
        quote: "Working with AT Architects was a seamless experience. They transformed our space into something truly special.",
        author: "Mrs. Priya Shah",
        position: "Client, Luxury Residence"
    }
];